'use client';

import dynamic from 'next/dynamic';
import type { ReactElement } from 'react';
import type { StyleOverrides } from '@/components/ui/RichText/RichText';
import type { ResolvedBookingCalendarDoctor } from '../types';
import type { BookingDisclaimerProps } from './BookingDisclaimer';
import type { Clinic } from '../types';

export interface LazyBookingCalendarWidgetClientProps {
  doctors: ResolvedBookingCalendarDoctor[];
  title?: string;
  description?: string;
  visibleDays?: number;
  startDate?: string;
  endDate?: string;
  className?: string;
  disclaimer?: BookingDisclaimerProps;
  autoOpenWhenSingleDoctor?: boolean;
  duration?: number;
  initialVisibleSlotCount?: number;
  mobileInitialVisibleSlotCount?: number;
  titleStyles?: StyleOverrides;
  descriptionStyles?: StyleOverrides;
  enableDoctorEnquiry?: boolean;
  clinic?: Clinic;
  filterAvailability?: boolean;
}

const HeavyClient = dynamic(
  () =>
    import('./BookingCalendarWidgetClient').then((m) => ({
      default: m.BookingCalendarWidgetClient,
    })),
  {
    ssr: false,
    loading: () => (
      <div
        className="min-h-[400px] w-full animate-pulse rounded-xl bg-gray-50"
        aria-hidden="true"
      />
    ),
  },
);

export function LazyBookingCalendarWidgetClient(
  props: LazyBookingCalendarWidgetClientProps,
): ReactElement {
  return <HeavyClient {...(props as any)} />;
}
